import { render } from "./proche_sorov_admin.vue?vue&type=template&id=f3c6f138&scoped=true"
import script from "./proche_sorov_admin.vue?vue&type=script&lang=js"
export * from "./proche_sorov_admin.vue?vue&type=script&lang=js"

import "./proche_sorov_admin.vue?vue&type=style&index=0&id=f3c6f138&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c6f138"]])

export default __exports__